import { render } from "./FormWizardPage.vue?vue&type=template&id=358a8bc8&ts=true"
import script from "./FormWizardPage.vue?vue&type=script&lang=ts"
export * from "./FormWizardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__